import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * triggers when the user is presented with a search results
 */
export interface ResultsView {
  /**
   * the value the user typed in and triggered the list of results
   */
  userInput: string;
  /**
   * list of results. if the results are games, send them as seperate entities
   */
  valueList?: [string, ...string[]] | null;
}

export const resultsView = (data: ResultsView, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/results_view/jsonschema/1-0-0', data },
    context
  });
